// src/components/SkyTab.jsx
export default function SkyTab({ active = false, variant = "default", className = "", children, ...rest }) {
    const isPrimary = active || variant === "primary";
    return (
        <button
            {...rest}
            className={[
                "h-9 px-4 rounded-full text-[13px] border transition",
                isPrimary
                    ? "bg-sky-700 text-white border-sky-700 hover:bg-sky-600"
                    : "bg-white text-slate-700 border-slate-300 hover:bg-slate-50",
                className,
            ].join(" ")}
        >
            {children}
        </button>
    );
}
